import axios from 'axios';

export class ApiError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly status?: number,
    public readonly details?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function normalizeError(error: unknown): ApiError {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    const data = error.response?.data as Record<string, unknown> | undefined;
    const message =
      (typeof data?.message === 'string' ? data.message : undefined) ??
      error.message ??
      'An unexpected error occurred';
    const code =
      (typeof data?.code === 'string' ? data.code : undefined) ?? `HTTP_${status ?? 'UNKNOWN'}`;

    return new ApiError(code, message, status, data);
  }

  if (error instanceof Error) {
    return new ApiError('UNKNOWN', error.message);
  }

  return new ApiError('UNKNOWN', 'An unexpected error occurred');
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}

export function isUnauthorized(error: unknown): boolean {
  return isApiError(error) && error.status === 401;
}
